import { render } from "./VoiceReaderControls.vue?vue&type=template&id=52fa3bff&scoped=true"
import script from "./VoiceReaderControls.vue?vue&type=script&lang=js"
export * from "./VoiceReaderControls.vue?vue&type=script&lang=js"

import "./VoiceReaderControls.vue?vue&type=style&index=0&id=52fa3bff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fa3bff"]])

export default __exports__